import IconButton from '@/components/buttons/richmenu/IconButton';
import Component from 'vue-class-component';

@Component({
  name: 'italic-button',
})
export default class ItalicButton extends IconButton {
}
